import { Box, Grid2, Typography, useColorScheme } from "@mui/material"
import { ReactComponent as SvgaLight } from './assets/light_mode/value_prop_2_a.svg'
import { ReactComponent as SvgbLight } from './assets/light_mode/value_prop_2_b.svg'
import { ReactComponent as SvgcLight } from './assets/light_mode/value_prop_2_c.svg'
import { ReactComponent as SvgaDark } from './assets/dark_mode/value_prop_2_a.svg'
import { ReactComponent as SvgbDark } from './assets/dark_mode/value_prop_2_b.svg'
import { ReactComponent as SvgcDark } from './assets/dark_mode/value_prop_2_c.svg'

const ValueProp2: React.FC = () => {
  const { mode, systemMode } = useColorScheme();

  const isLightMode = ( mode === 'light' || (mode === 'system' && systemMode === 'light'));

  const ImgAsvg = isLightMode ? SvgaLight : SvgaDark;
  const ImgBsvg = isLightMode ? SvgbLight : SvgbDark;
  const ImgCsvg = isLightMode ? SvgcLight : SvgcDark;

  const CardItems = [
    {
      id: "vp2-1",
      Image: ImgAsvg,
      title: "1. Connect content",
      description: "Add your audio, documents, web-links, videos, blogs, podcasts, journal entries..."
    },
    {
      id: "vp2-2",
      Image: ImgBsvg,
      title: "2. Fine-tune performance",
      description: "The model learns your tone, voice, and expertise as you interact with it"
    },
    {
      id: "vp2-3",
      Image: ImgCsvg,
      title: "3. Fans interact / You Learn & Earn",
      description: "Fans interact 24/7 through chat, creating insights and passive income"
    },

  ]

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        px: {xs: 2.5, md: 5},
        py: {xs: 3, md: 4},
        gap: {xs: 3, md: 4},
        maxWidth: "lg",
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          // gap: 1,
          width: '100%',
          maxWidth: '580px',
        }}
      >
        <Typography variant="h5">
          Launch your AI persona in minutes
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Soopra lets you train a smart, on-brand AI version of yourself that
          engages your audience, promotes your work, and generates passive income.
        </Typography>
      </Box>

      <Grid2
        container
        spacing={{xs: 3, md: 4, }}
      >
        {
          CardItems.map((item) =>
            <CardItem
              key={item.id}
              id={item.id}
              Image={item.Image}
              title={item.title}
              description={item.description}
            />
          )
        }
      </Grid2>
    </Box>
  )
}

export default ValueProp2;

interface CardItemProps {
  id: string;
  Image: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
}

const CardItem: React.FC<CardItemProps> = ({id, Image, title, description}) => {
  return (
    <Grid2 id={id}
      size={{xs: 12, laptop: 4}}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: 1.5,
        py: {xs: 2, md: 3},
        borderRadius: 3,
        backgroundColor: (theme) => theme.palette.background["container-1"],
        elevation: 1,
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Image />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 1,
        }}
      >
        <Typography variant="h6">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Grid2>
  )
}
